export type P3Risk = {
    code: string;
    summary: string;
    causes: string[];
    event: string;
    consequences: string;
    citizen_impact: string;
    impact: "low" | "medium" | "high";
    probability: "low" | "medium" | "high";
    level: "trivial" | "moderate" | "high" | "intolerable";
    dimension: string;
    cluster: "revenue_integrity" | "operational_efficiency" | "governance";
    audit_response: string;
};

export type P3FormData = { risks: P3Risk[] };

export function defaultP3FormData(): P3FormData {
    return { risks: [] };
}

export function computeRiskLevel(
    impact: P3Risk["impact"],
    probability: P3Risk["probability"],
): P3Risk["level"] {
    const score = (v: string) => (v === "high" ? 3 : v === "medium" ? 2 : 1);
    const total = score(impact) * score(probability);
    if (total >= 9) return "intolerable";
    if (total >= 6) return "high";
    if (total >= 4) return "moderate";
    return "trivial";
}
